import React, { useMemo, useState } from 'react';
import styled from 'styled-components';
import fileSaver from 'file-saver';

import Card from 'antd/es/card';
import Spin from 'antd/es/spin';
import message from 'antd/es/message';

import ReportService from 'services/reports';

import useForm from 'hooks/useForm';

import MainLayout from 'layouts/Main.layout';
import { Row, Col } from 'components/layout';
import PageHeader from 'components/MainPageHeader';

import CreateReportForm from '../components/CreateReportForm';
import { useAgencySelect, useEmployeeSelect } from 'hooks/useSelect';
import { REPORT_TYPE_OPTIONS } from '../constants';
import { useFeatureToggleItems } from 'components/FeatureToggle';
import featureToggles from 'config/featureToggles';

const reportsService = new ReportService();

const ReportsPage = () => {
  const reportsFeatureToggles = useFeatureToggleItems(featureToggles.REPORTS);
  const agencySelect = useAgencySelect();
  const individualSelect = useEmployeeSelect();
  const [loading, setLoading] = useState(false);

  const reportTypeOptions = useMemo(() => {
    const options = [...REPORT_TYPE_OPTIONS].map(option => {
      const optionFeatureToggle = reportsFeatureToggles.find(toggle => toggle.itemName.toLowerCase() === option.value.toLowerCase());
      if ((optionFeatureToggle && optionFeatureToggle.visible === true) || option.value==='Container') {
        option.disabled =false;
      } else {option.disabled=true}
      return option;
    });
    return options;
  }, [reportsFeatureToggles]);

  const [form] = useForm({
    onSubmit: async (values) => {
      const { individualId, agencyId, shifts, from, to, reportType } = values;
      setLoading(true);
      try {
        let res;
        if (reportType === 'WorkPrediction') {
          res = await reportsService.generateWorkPrediction();
        } else {
          res = await reportsService.generateReport({
          ReportType: ['Container', 'ShiftPerformance', 'EmployeePerformance', 'WorkPrediction'].includes(reportType) ? reportType : null,
          Start: from.format('YYYY-MM-DD'),
          End: to.format('YYYY-MM-DD'),
          EmployeeId: individualId || null,
          AgencyId: agencyId || null,
          Shifts: shifts ? shifts.join(',') : '',
          ContainerType: null,
        });
      }
        if(res.Success === false)
        {
          const errorMessage = res.Error;
          message.error(errorMessage, 10);
        }
        else
        {
          const { url, fname, contentType } = res;
          fileSaver.saveAs(url, fname, { type: contentType });
        }
      } catch (err) {
        if (err?.response?.status === 502) {
        message.error('Report timeout limit reached, please try a shorter report date range!', 10);
      } else {
        message.error('An unexpected error occurred.', 10);
      }
    } finally {
      setLoading(false);
    }
  },
});

  return (
    <>
    {loading && (
      <FullPageSpinner>
        <Spin tip="Generating report..." size="large" />
      </FullPageSpinner>
    )}
    <MainLayout>
      <PageHeader
        title="Reports"
        icon="file-text"
      />
      <Row style={{ padding: '0 24px', height: 'calc(100vh - 92px)' }}>
        <Col span={24}>
          <StyledCard bordered={false}>
            <CreateReportForm
              form={form}
              reportTypeOptions={reportTypeOptions}
              agencyOptions={agencySelect.options}
              individualOptions={individualSelect.options}
            />
          </StyledCard>
        </Col>
      </Row>
    </MainLayout>
    </>
  );
};

const StyledCard = styled(Card)`
  background-color: #fff;
  height: 100%;

  & .ant-card-body {
    display: flex;
    justify-content: center;
  }
`;

const FullPageSpinner = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(255, 255, 255, 0.6); // or use #f0f2f5 for AntD theme
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export default ReportsPage;
